import {Component, Input, ViewChild} from '@angular/core';
import { ReplaceEmojisPipe } from '../../../../pipes/emoji.pipe';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {NgxModalDraggableDirective} from '../../../../directives/draggable.directive';

@Component({
  selector: 'app-modal-copy-text',
  templateUrl: './modal-copy-text.component.html',
  styleUrls: ['./modal-copy-text.component.scss']
})
export class ModalCopyTextComponent {
  @Input() text: any;
  public modalDirective: NgxModalDraggableDirective;
  @ViewChild(NgxModalDraggableDirective)
  set setDirective(directive: NgxModalDraggableDirective) {
    this.modalDirective = directive;
  }
  constructor(public bsModalRef: BsModalRef) {}

}
